/**
 * Teeplora compatibility patch for the Printify "Personalize button" app block.
 *
 * Problem: the Printify personalize app reads the currently selected
 * Color/Size option by looking for inputs named exactly like the option
 * (e.g. name="Color", name="Size", name="options[Color]"). Dawn's own
 * variant picker names its inputs with a positional suffix instead
 * (e.g. name="Color-1\n"), so the app can never detect what the shopper
 * actually selected and always falls back to the product's default
 * variant. That mismatch is what causes the personalized image/design to
 * disappear and "Add to cart" to lose the saved personalization once the
 * shopper picks a Color/Size.
 *
 * Fix: keep a hidden, always-checked mirror input per option, named
 * exactly like the option (no suffix), whose value is kept in sync with
 * whatever the shopper actually has selected in Dawn's real fieldset.
 * This does not touch Dawn's own inputs/behavior at all - it only adds
 * extra inputs the Printify script can find.
 */
(function () {
  function optionNameFromRawName(rawName) {
    if (!rawName) return null;
    // Strip a trailing "-<number>" (with possible trailing whitespace/newline)
    // e.g. "Color-1\n" -> "Color"
    return rawName.replace(/-\d+\s*$/, '').trim() || null;
  }

  function currentFieldsetValue(fieldset, select) {
    var checked = fieldset.querySelector('input:checked');
    if (checked) return checked.value;
    if (select) return select.value;
    return '';
  }

  function syncMirror(fieldset, mirror, select) {
    var value = currentFieldsetValue(fieldset, select);
    if (mirror.value !== value) mirror.value = value;
  }

  function setupFieldset(fieldset) {
    if (fieldset.dataset.personalizeCompatDone === '1') {
      // Already wired up; just refresh the mirror's value in case the
      // fieldset was swapped/re-rendered by Dawn's AJAX variant update.
      var existing = fieldset.querySelector('[data-personalize-mirror]');
      if (existing) syncMirror(fieldset, existing, fieldset.querySelector('select'));
      return;
    }

    var input = fieldset.querySelector('input[type="radio"], input[type="checkbox"]');
    var select = fieldset.querySelector('select');
    var rawName = input ? input.name : select ? select.name : null;
    var optionName = optionNameFromRawName(rawName);
    if (!optionName) return;

    var mirror = document.createElement('input');
    mirror.type = 'checkbox';
    mirror.checked = true;
    mirror.name = optionName;
    mirror.setAttribute('data-personalize-mirror', optionName);
    mirror.setAttribute('aria-hidden', 'true');
    mirror.tabIndex = -1;
    mirror.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';

    syncMirror(fieldset, mirror, select);
    fieldset.appendChild(mirror);

    fieldset.addEventListener('change', function () {
      syncMirror(fieldset, mirror, select);
    });

    fieldset.dataset.personalizeCompatDone = '1';
  }

  function initPersonalizeCompat() {
    document.querySelectorAll('fieldset').forEach(setupFieldset);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPersonalizeCompat);
  } else {
    initPersonalizeCompat();
  }

  // Dawn replaces the product form's inner HTML (including fieldsets) via
  // AJAX whenever a variant option changes. Re-run shortly after any
  // change event and observe DOM swaps so the mirrors stay attached and
  // in sync with the freshly rendered fieldsets.
  document.addEventListener('change', function () {
    setTimeout(initPersonalizeCompat, 50);
  });

  var target = document.querySelector('main') || document.body;
  if (target && window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length);
      });
      if (relevant) initPersonalizeCompat();
    });
    observer.observe(target, { childList: true, subtree: true });
  }
})();
